/*
 * @Author: mikey.zhaopeng
 * @Date: 2021-07-05 16:11:04
 * @Last Modified by: mikey.zhaopeng
 * @Last Modified time: 2021-07-07 18:29:54
 */
import YxTextArea, { defaultProps } from "./yxTextArea";
import { IYxInputPropTypes } from "../IpropType/basePropType";
import propTypes from "prop-types";
YxTextArea.propTypes = {
  ...IYxInputPropTypes,

  //文本域的大小是否根据内容决定，参考antd官网
  autosize: propTypes.oneOfType([propTypes.bool, propTypes.object]),
};
YxTextArea.defaultProps = defaultProps();

export default YxTextArea;



// WEBPACK FOOTER //
// ./src/yx-widget/component/YxInput/YxTextArea/index.js